<kendo-buttongroup selection="single">
  @for (buttonConfig of buttonsConfig; track buttonConfig.name) {
    <button kendoButton
            [themeColor]="'tertiary'"
            [toggleable]="true"
            [selected]="buttonConfig.selected"
            (selectedChange)="setUsersConfig(buttonConfig)"
            [disabled]="buttonConfig.disabled"
    >{{buttonConfig.title}}</button>
  }
</kendo-buttongroup>
